// Hero slider
$(document).ready(function () {
  let slideImages = $('.hero-slide')
  let current = 0
  let interval = setInterval(function () {
    nextSlide()
  }, 5000)

  // $('#sliderContainer').on('mouseenter', function(){
  //	clearInterval(interval);
  //});

  // Clear All Images
  function reset() {
    for (let i = 0; i < slideImages.length; i++) {
      slideImages[i].classList.remove('slide-active')
    }
  }

  function startSlide() {
    reset()
    slideImages[0].classList.add('slide-active')
    $('#slideCurrent').text(current + 1)
  }

  // Show Prev
  function slideLeft() {
    reset()
    slideImages[current - 1].classList.add('slide-active')
    current--
  }

  // Left Arrow Click
  $('#prev').on('click', function () {
    if (current === 0) {
      current = slideImages.length
    }
    slideLeft()
    $('#slideCurrent').text(current + 1)
  })

  // Show Next
  function slideRight() {
    reset()
    slideImages[current + 1].classList.add('slide-active')
    current++
  }

  function nextSlide() {
    if (current === slideImages.length - 1) {
      current = -1
    }
    slideRight()
    let currentStep = current + 1
    $('.step').removeClass('active')
    $('.step').eq(current).addClass('active')
    $('#slideCurrent').text(current + 1)
    // console.log(current)
  }

  //Right Arrow Click
  $('#next').on('click', function () {
    nextSlide()
  })

  // Insert Total Slides
  $('#slideTotal').text(slideImages.length)
  for (let step = 0; step < slideImages.length; step++) {
    if (current == step) {
      $('#sliderControls').append(
        `<div class="step active" data-step="${step}"></div>`
      )
    } else {
      $('#sliderControls').append(
        `<div class="step" data-step="${step}"></div>`
      )
    }
  }

  $('.step').on('click', function () {
    const step = $(this).data('step')
    current = step

    $('.step').removeClass('active')
    $('.step').eq(step).addClass('active')

    reset()
    slideImages[step].classList.add('slide-active')
  })

  startSlide()
})
